/**
Copyright [2022] [https://www.merac.com
 */
import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/sys/userCenter/${url}`, ...arg)
/**
 * 鐢ㄦ埛涓汉鎺у埗鍣?
 *
 * @author yubaoshan
 * @date 2022-09-22 22:33:20
 */
export default {
	// 鑾峰彇鍥剧墖楠岃瘉鐮?
	userGetPicCaptcha(data) {
		return request('getPicCaptcha', data, 'get')
	},
	// 鎵惧洖瀵嗙爜鑾峰彇鎵嬫満楠岃瘉鐮?
	userFindPasswordGetPhoneValidCode(data) {
		return request('findPasswordGetPhoneValidCode', data, 'get')
	},
	// 鎵惧洖瀵嗙爜鑾峰彇閭楠岃瘉鐮?
	userFindPasswordGetEmailValidCode(data) {
		return request('findPasswordGetEmailValidCode', data, 'get')
	},
	// 閫氳繃鎵嬫満鍙锋壘鍥炵敤鎴峰瘑鐮?
	userFindPasswordByPhone(data) {
		return request('findPasswordByPhone', data)
	},
	// 閫氳繃閭鎵惧洖鐢ㄦ埛瀵嗙爜
	userFindPasswordByEmail(data) {
		return request('findPasswordByEmail', data)
	},
	// 淇敼鐢ㄦ埛瀵嗙爜
	userUpdatePassword(data) {
		return request('updatePassword', data)
	},
	// 淇敼鐢ㄦ埛澶村儚
	userUpdateAvatar(data) {
		return request('updateAvatar', data)
	},
	// 淇敼鐢ㄦ埛绛惧悕鍥剧墖
	userUpdateSignature(data) {
		return request('updateSignature', data)
	},
	// 鑾峰彇鐧诲綍鐢ㄦ埛鐨勮彍鍗?
	userLoginMenu(data) {
		return request('loginMenu', data, 'get')
	},
	// 鑾峰彇鐧诲綍鐢ㄦ埛缁勭粐鏍?
	userLoginOrgTree(data) {
		return request('loginOrgTree', data, 'get')
	},
	// 鑾峰彇鐧诲綍鐢ㄦ埛鐨勮亴浣嶄俊鎭?
	userLoginPositionInfo(data) {
		return request('loginPositionInfo', data, 'get')
	},
	// 缂栬緫涓汉淇℃伅
	userUpdateUserInfo(data) {
		return request('updateUserInfo', data)
	},
	// 缂栬緫涓汉宸ヤ綔鍙?
	userUpdateUserWorkbench(data) {
		return request('updateUserWorkbench', data)
	},
	// 鑾峰彇鐧诲綍鐢ㄦ埛鐨勫伐浣滃彴
	userLoginWorkbench(data) {
		return request('loginWorkbench', data, 'get')
	},
	// 获取登录用户 PC 桌面布局
	userLoginDesktopLayout(data) {
		return request('loginDesktopLayout', data, 'get')
	},
	// 编辑个人 PC 桌面布局（拖动高频：关闭统一成功 toast）
	userUpdateDesktopLayout(data) {
		return request('updateUserDesktopLayout', data, 'post', { showSuccessMessage: false })
	},
	// 鑾峰彇鐧诲綍鐢ㄦ埛鐨勭珯鍐呬俊鍒嗛〉
	userLoginUnreadMessagePage(data) {
		return request('loginUnreadMessagePage', data, 'get')
	},
	// 璇诲彇鐧诲綍鐢ㄦ埛绔欏唴淇¤鎯?
	userLoginUnreadMessageDetail(data) {
		return request('loginUnreadMessageDetail', data, 'get')
	}
}
